module.exports = __webpack_public_path__ + "static/media/jcb.524e36f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/payment-methods/jcb.png
// module id = 579
// module chunks = 0